// This is the Laura entry point file.
// There should be no custom code written directly in this file.

import './laura.main.css';
import './utils/accordion';
import './utils/localization';
import './utils/local-price-format';
import './utils/cardigan';
import './utils/lazy-image';
import './utils/kustomer-loader';
import Global from './utils/global';

window.STOREFRONT = 'LC';

// Load any global js functionality
Global();
